import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function MemoryBank() {
  const [memories, setMemories] = useState({ seeds: [], evolutions: [], backflows: [] });
  useEffect(() => {
    axios.get('/api/memory').then(res => setMemories(res.data));
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <h1 className="text-3xl font-bold mb-6">关键要素记忆库 (简易·回灌沉淀)</h1>
      <div className="grid grid-cols-3 gap-6">
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl mb-4">种子记忆</h2>
          {memories.seeds.map((s,i) => <div key={i} className="mb-2 text-sm">{s.title}</div>)}
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl mb-4">演化剧本</h2>
          {memories.evolutions.map((e,i) => <div key={i} className="mb-2 text-sm">{e.stage}: {e.lesson}</div>)}
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl mb-4">回灌记录</h2>
          {memories.backflows.map((b,i) => <div key={i} className="mb-2 text-sm">{b.type}: {b.count}次</div>)}
        </div>
      </div>
    </div>
  );
}
